export default "__VITE_ASSET__BpEPgDBz__"